module.exports = __webpack_public_path__ + "img/1.2c5134b5.jpg";